"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("./base");
var Size = /** @class */ (function (_super) {
    tslib_1.__extends(Size, _super);
    function Size(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.type = 'size';
        _this.names = ['size'];
        return _this;
    }
    return Size;
}(base_1.default));
exports.default = Size;
//# sourceMappingURL=size.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/attr/lib/attributes/size.js
// module id = 756
// module chunks = 37